module.exports = __webpack_public_path__ + "img/c3615f7aa6c96ebae5d14fb0b4508670.9179dbfc.jpg";